<template>
    <div>
        <mag-teaser-articles
            v-for="(category, index) in filteredCategories"
            :articles="articlesByCategoryName[category.name] || []"
            :background="index % 2"
            :category="category"
            :id="category.name"
            :key="category.name"
        />
    </div>
</template>

<script>
import MagTeaserArticles from "./MagTeaserArticles.vue";
import { groupBy, isArray } from "lodash";
import { Services } from "src/services/Services";

export default {
    components: { MagTeaserArticles },
    props: ["categories"],
    data() {
        return {
            articlesByCategoryName: {},
        };
    },
    async created() {
        const articles = await Services.api.mag.getArticles();
        this.articlesByCategoryName = groupBy(articles, a => a.articleCategoryName);
        this.$emit("articlesLoaded", {});
    },
    computed: {
        filteredCategories() {
            if (!isArray(this.categories)) return [];
            return this.categories.filter(
                category =>
                    isArray(this.articlesByCategoryName[category.name]) &&
                    this.articlesByCategoryName[category.name].length > 0
            );
        },
    },
};
</script>

<style lang="sass" scoped></style>
